import { render, staticRenderFns } from "./aws.vue?vue&type=template&id=1cd8df4e&"
import script from "./aws.vue?vue&type=script&lang=js&"
export * from "./aws.vue?vue&type=script&lang=js&"
import style0 from "./aws.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports